import { RotationsplanVorlageSheet } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplanVorlage/components/RotationsplanVorlageSheet';
import { useForm } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplanVorlage/useForm';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function CreateRotationsplanVorlage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    store: {
      data: { berufe },
    },
  } = useRotationsplanFeatureContext();
  const { form, titelVergeben } = useForm();

  return (
    <RotationsplanVorlageSheet
      titel={t('domain.mitarbeiter.rotationsplan.vorlagen.createVorlage.titel')}
      berufe={berufe}
      form={form}
      titelVergeben={titelVergeben}
      close={() =>
        navigate('/mitarbeiter/rotationsplaene/vorlagen', { replace: true })
      }
    />
  );
}
